function normalizeEmail(value) {
    return String(value || "").trim().toLowerCase();
}

function addAccountIdentity(conversations, contacts) {
    const contactsByEmail = new Map();
    for (const contact of Array.isArray(contacts) ? contacts : []) {
        const email = normalizeEmail(contact?.email);
        if (email && !contactsByEmail.has(email)) {
            contactsByEmail.set(email, contact);
        }
    }

    return (Array.isArray(conversations) ? conversations : []).map((conversation) => {
        const contact = contactsByEmail.get(normalizeEmail(conversation?.contact_email));
        const accountName = String(
            contact?.account || contact?.organization_name || contact?.company || ""
        ).trim();
        return accountName ? { ...conversation, account_name: accountName } : conversation;
    });
}

export { addAccountIdentity };